module.exports = __webpack_public_path__ + "img/home.3bd5a0d6.svg";